<script setup lang="ts">
const mailpitUrl = import.meta.env.VITE_MAILPIT_WEB_URL
</script>

<template>
  <UButton
    v-if="mailpitUrl"
    label="Open Mailpit"
    icon="i-lucide-mail"
    variant="subtle"
    color="neutral"
    size="xs"
    :to="mailpitUrl"
    target="_blank"
  />
</template>
